import {
  after,
  cloneDeepWith,
  isPlainObject,
  isEmpty,
  map,
  pick,
} from 'lodash';
import { v1 as uuid } from 'uuid';
import { QUESTION_NEST_PEEQ } from 'data/nodeTypes';
import messages from './messages';

export const createAudience = (remainingCompletes) => ({
  refId: uuid(),
  criteria: [],
  quotaCompletes: remainingCompletes,
});

export const duplicateAudience = (audience) =>
  cloneDeepWith(audience, function customizer(value, key) {
    // remove id properties as those are always from the DB
    if (isPlainObject(value)) {
      // return cloneDeepWith(omit(value, 'id'), after(2, customizer));
      return cloneDeepWith(value, after(2, customizer));
    }
    // create new refId when found
    if (key === 'refId') return uuid();

    return undefined;
  });

export const featureCleanerNonNesting = ({
  key,
  values,
  hasQuotas,
  excludeOptions,
  style,
}) => {
  const cleanValueKeys = [
    'value',
    'quotaCompletes',
    'id',
    'refId',
    'label',
    'isGroup',
    'groupName',
    'values',
  ];

  const cleanValues = map(values, (value) => pick(value, cleanValueKeys));

  return {
    key,
    hasQuotas,
    values: cleanValues,
    excludeOptions,
    style,
  };
};

export const featureCleanerNesting = ({
  key,
  style,
  features,
  relations,
  hasQuotas,
}) => ({
  key,
  style,
  features,
  relations,
  hasQuotas,
});

export const featureCleaner = (criteriaList) =>
  criteriaList
    .filter(
      ({ style, values, relations }) =>
        (style !== QUESTION_NEST_PEEQ && !isEmpty(values)) ||
        (style === QUESTION_NEST_PEEQ && !isEmpty(relations)),
    )
    .map((feature) =>
      feature.style === QUESTION_NEST_PEEQ
        ? featureCleanerNesting(feature)
        : featureCleanerNonNesting(feature),
    );

export const getAudienceName = (name, index, intl) =>
  name || intl.formatMessage(messages.audienceList.title, { index: index + 1 });
